import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    submitted: false,
    error: false,
    errorMessage: '',
    errorMessageData: '',
    privacyPolicyDocumentLink:'',
    generalTermsOFUseLink:''
}

export const partnerIDSlice = createSlice({
    name: 'partnerID',
    initialState,
    reducers: {
        partnerIDOperationInprogress: () => {
            return {
                ...initialState,
                loading: true
            }
        },
        partnerIDSupportDocumentsProcessed: (state, { payload }) => {
            return {
                ...state,
                loading: false,
                ...payload
            }
        },
        partnerIDOperationProcessed: (state, { payload }) => {
            return {
                ...initialState,
                ...payload,
                submitted: !payload.error
            }
        },
        partnerIDOperationCompleted: () => {
            return initialState
        },
        
    }
});

export const { partnerIDOperationInprogress,partnerIDSupportDocumentsProcessed, partnerIDOperationProcessed, partnerIDOperationCompleted } = partnerIDSlice.actions;

export default partnerIDSlice.reducer;